import React, { useState } from 'react'
import { Box } from '@mui/material';
import NoticeListContainer from '../../containers/noticemng/NoticeListContainer';
import NoticeFormContainer from '../../containers/noticemng/NoticeFormContainer';
import { useDispatch } from 'react-redux';
import { listNotices } from '../../modules/noticeModule/notices';

const NoticeMngTemplate = () => {
    const dispatch = useDispatch();
    const [type, setType] = useState('add');
    const [data, setData] = useState(null);
    const [open, setOpen] = useState(false);
    const [searchData, setSearchData] = useState(null);
    const handleOpen = () => {
        setOpen(true)
    };
    const handleClose = () => {
        setOpen(false);
        setData(null);
    };

    const handleAdd = () => {
        setType('add');
        setData(null);
        setOpen(true);
    }

    const selectedNotice = (notice) => {
        //console.log(params, 'parent');
        setType('edit');
        setData(notice);
        setOpen(true);
    };

    const onSearch = (search) => {
        setSearchData(search);
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                m: 1,
            }}
        >
            <NoticeListContainer searchData={searchData} onSearch={onSearch} selectedNotice={selectedNotice} handleAdd={handleAdd} />
            <NoticeFormContainer
                type={type}
                data={data}
                open={open}
                searchData={searchData}
                handleClose={handleClose}
            />

        </Box>
    )
}

export default NoticeMngTemplate